import React from 'react';
import { Container } from 'react-bootstrap';

const OutsourcingVsFull5 = props => {

    return (
        <section id="outsourcing-vs-full-section5" className="my pt-5">
            <div className='white-shape'></div>
            <Container>
                <div className="title-triangle top-md fw-600"></div>
                <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingVsFull:section-5.title')}</h2>
                <p className='mb-4'>{props.t('services:outsourcingVsFull:section-5.txt')}</p>
                <ul className='mb-4'>
                    {props.t('services:outsourcingVsFull:section-5.list', { returnObjects: true }).map((item, index) => (
                        <li key={index}><p className='m-0'>{item}</p></li>
                    ))}
                </ul>
                <p className='m-0'>{props.t('services:outsourcingVsFull:section-5.text')}</p>
            </Container>
        </section>
    );
};

export default OutsourcingVsFull5;
